module.exports = __webpack_public_path__ + "static/media/help.3067476a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Media/help.svg
// module id = 33
// module chunks = 0